intra_module.factory('User', function($resource, api_url, hub_api_url) {
    const url    = `${api_url}/users/:login`;
    const params =
        {login: '@login'};

    const actions = {
        me: {
            method: 'GET',
            url:    `${api_url}/`
        },

        getById: {
            method: 'GET',
			url:    `${hub_api_url}/users/:id`,
            cache:  true,
            params: {
                id: '@id'
            }
        }
    };

    return $resource(url, params, actions);
});
